__turbopack_context__.v({
  "activeOption": "ManagedServiceIntake-module__zOg-la__activeOption",
  "assurances": "ManagedServiceIntake-module__zOg-la__assurances",
  "engagementOption": "ManagedServiceIntake-module__zOg-la__engagementOption",
  "engagementToggle": "ManagedServiceIntake-module__zOg-la__engagementToggle",
  "eyebrow": "ManagedServiceIntake-module__zOg-la__eyebrow",
  "intro": "ManagedServiceIntake-module__zOg-la__intro",
  "layout": "ManagedServiceIntake-module__zOg-la__layout",
  "lede": "ManagedServiceIntake-module__zOg-la__lede",
  "legal": "ManagedServiceIntake-module__zOg-la__legal",
  "selectionSlide": "ManagedServiceIntake-module__zOg-la__selectionSlide",
  "surface": "ManagedServiceIntake-module__zOg-la__surface",
  "vipBanner": "ManagedServiceIntake-module__zOg-la__vipBanner",
  "workflow": "ManagedServiceIntake-module__zOg-la__workflow",
});
